export default __webpack_public_path__ + "static/media/benefits_shadow.ee929d8b.svg";